export const APP_ROUTES = {
  HOME: "/",

  EDIT_PROFILE: "/edit-profile",

  CHECK_IN: "/check-in",
  CHECK_OUT: "/check-out",

  APPROVE_VISIT_REQUEST: "/approve-visit-request",
  SEARCH_VISIT_REQUEST: "/search-visit-request",
  CREATE_VISIT_REQUEST: "/create-visit-request",

  APPROVE_REQUEST: "/approve-request",
  UPDATE_REQUEST: "/update-request",

  INDIVIDUAL_VISIT_REQUEST: "/create-visit-request/individual",
  GROUP_VISIT_REQUEST: "/create-visit-request/group",
  VIP_VISIT_REQUEST: "/create-visit-request/vip",

  APPROVE_PERMIT_REQUEST: "/approve-permit-request",
  SEARCH_PERMIT_REQUEST: "/search-permit-request",

  WAREHOUSE_IN_OUT_PERMIT: "/warehouse-in-out-permit",
  UPDATE_WAREHOUSE_IN_OUT_PERMIT: "/update-warehouse-in-out-permit",
  APPROVE_WAREHOUSE_IN_OUT_PERMIT: "/approve-warehouse-in-out-permit",

  PC_IN_OUT_PERMIT: "/pc-in-out-permit",
  UPDATE_PC_IN_OUT_PERMIT: "/update-pc-in-out-permit",
  APPROVE_PC_IN_OUT_PERMIT: "/approve-pc-in-out-permit",

  PERMIT_TO_WORK: "/permit-to-work",
  UPDATE_PERMIT_TO_WORK: "/update-permit-to-work",
  APPROVE_PERMIT_TO_WORK: "/approve-permit-to-work",

  LOST_VEHICLE_STICKER_ID_CARD: "/lost-vehicle-sticker-id-card",
  UPDATE_LOST_VEHICLE_STICKER_ID_CARD: "/update-lost-vehicle-sticker-id-card",
  APPROVE_LOST_VEHICLE_STICKER_ID_CARD: "/approve-lost-vehicle-sticker-id-card",

  PARKING_STICKER_REQUEST: "/parking-sticker-request",
  UPDATE_PARKING_STICKER_REQUEST: "/update-parking-sticker-request",
  APPROVE_PARKING_STICKER_REQUEST: "/approve-parking-sticker-request",

  OFFICE_ACCESS_AUTHORIZATION: "/office-access-authorization",
  UPDATE_OFFICE_ACCESS_AUTHORIZATION: "/update-office-access-authorization",
  APPROVE_OFFICE_ACCESS_AUTHORIZATION: "/approve-office-access-authorization",

  ISSUANCE_RENEWAL_ID_FOR_STAFF_FROM_CONTRACTED_COMPANIES: "/issuance-renewal-id-for-staff-from-contracted-companies",
  UPDATE_ISSUANCE_RENEWAL_ID_FOR_STAFF_FROM_CONTRACTED_COMPANIES: "/update-issuance-renewal-id-for-staff-from-contracted-companies",
  APPROVE_ISSUANCE_RENEWAL_ID_FOR_STAFF_FROM_CONTRACTED_COMPANIES: "/approve-issuance-renewal-id-for-staff-from-contracted-companies",

  ADD_USERS: "/add-users",
  SEARCH_USERS: "/search-users",
  MANAGE_ROLES: "/manage-roles",

  INTERNAL_CONFIG: "/configuration/internal-config",
  SYSTEM_CODES: "/configuration/system-codes",
  VISIT_PURPOSE: "/configuration/visit-purpose",
  EMAIL_CONFIG: "/configuration/email-config",
  LOCATIONS: "/configuration/locations",
  DEPARTMENTS: "/configuration/departments",
  MEETING_ROOMS_CONFIG: "/configuration/meeting-rooms-config",
  ACCESS_LEVELS: "/configuration/access-levels",
  ACTIVE_DIRECTORY_CONFIG: "/configuration/active-directory-config",
  DYNAMIC_WORKFLOW_CONFIG: "/configuration/dynamic-workflow-config",
  BUILDINGS_CONFIGURATION: "/configuration/buildings-configuration",
  EXTERNAL_HELP_CONFIG: "/configuration/external-help-config",
  SMS_CONFIG: "/configuration/sms-config",
  GATES_CONFIG: "/configuration/gates-config",
  CRITICAL_NATIONALITIES_CONFIG: "/configuration/critical-nationalities-config",
  ACCESS_GROUPS: "/configuration/access-groups",
  DEVICES_CONFIG: "/configuration/devices-config",
  FR_CONFIG: "/configuration/fr-config",
  MUSTER_POINTS_CONFIG: "/configuration/muster-points-config",

  VISIT_REQUEST_REPORT: "/reports/visit-request-report",
  ACCESS_LOG_REPORT: "/reports/access-log-report",
  EMPLOYEE_REPORT: "/reports/employee-report",
  LOGIN_USER_REPORT: "/reports/login-user-report",
  AUDIT_LOGS_REPORT: "/reports/audit-logs-report",
  EXTERNAL_USERS_REPORT: "/reports/external-users-report",
  VISITORS_REPORT: "/reports/visitors-report",
  OVERSTAYED_VISITORS_REPORT: "/reports/overstayed-visitors-report",
  FR_ERRORS_REPORT: "/reports/fr-errors-report",
  BLACKLISTING_REPORT: "/reports/blacklisting-report",
  RATING_REPORT: "/reports/rating-report",

  VISIT_SUBMITTED: "/email-templates/visit-submitted",
  VISIT_REQUEST_SCHEDULE_TEMPLATE:
    "/email-templates/visit-request-schedule-template",
  VISIT_APPROVED_HOST_EMAIL: "/email-templates/visit-approved-host-email",
  VISIT_REQUEST_REJECTED_TEMPLATE:
    "/email-templates/visit-request-rejected-template",
  EMAIL_TO_HOST_TEMPLATE: "/email-templates/email-to-host-template",
  VISIT_REJECTED_HOST_EMAIL: "/email-templates/visit-rejected-host-email",
  EXTERNAL_PASSWORD_RESET: "/email-templates/external-password-reset",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_HOST:
    "/email-templates/external-visit-request-cancel-to-host",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR:
    "email-templates/external-visit-request-cancel-to-visitor",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_HOST:
    "/email-templates/internal-visit-request-cancel-to-host",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR:
    "email-templates/internal-visit-request-cancel-to-visitor",
  EXTERNAL_ACCOUNT_REGISTRATION_TEMPLATE:
    "email-templates/external-account-registration-template",
  VISIT_REQUESTED_INFO_TO_VISITOR:
    "email-templates/visit-requested-for-information-to-visitor-template",
  VISIT_REQUESTED_INFO_TO_STAFF:
    "email-templates/visit-requested-for-information-to-host-template",
  VISITOR_CHECK_IN: "/email-templates/visitor-check-in-template",
  VISITOR_CHECK_OUT: "/email-templates/visitor-check-out-template",
  OTP_TEMPLATE: "/email-templates/otp-template",
  EMERGENCY_EVACUATION_TEMPLATE:
    "/email-templates/emergency-evacuation-template",
  FINAL_PERMIT_APPROVAL_TEMPLATE:
    "/email-templates/final-permit-approval-template",

  ADD_EMPLOYEE: "/add-employee",
  SEARCH_EMPLOYEE: "/search-employee",

  ADD_BLACKLIST_VISITOR: "/add-blacklist-visitor",
  SEARCH_BLACKLIST_VISITORS: "/search-blacklist-visitors",

  LIVE_EVACUATION_DASHBOARD: "/emergency-evacuation/live-evacuation-dashboard",
  START_EVACUATION: "/emergency-evacuation/start-evacuation",
  UPDATE_EVACUATION: "/emergency-evacuation/update-evacuation",
  MUSTER_STATION: "/emergency-evacuation/muster-station",
  EVACUATION_EVENTS: "/emergency-evacuation/evacuation-events",
  EVACUATION_REPORT: "/emergency-evacuation/evacuation-report",

  NOT_FOUND: "/*",
  UNAUTHORIZED: "/un-authorized",
};

export const AUTH_ROUTES = {
  LOGIN: "/auth/login",
  OTP: "/auth/otp",
  SIGNIN_OIDC: "/signin-oidc",
};

export enum ROUTE_NAMES {
  // HOME = "HOME",
  HOME_SEARCH = "Home.Search",
  HOME_EXPORT = "Home.Export",

  // EDIT_PROFILE
  // EDIT_PROFILE_SEARCH = "EditProfile.Search",
  EDIT_PROFILE_SEARCH = "VisitRequest.Approvals", // change
  EDIT_PROFILE_UPDATE = "EditProfile.Update",

  // BLACKLIST
  BLACKLIST_SEARCH = "Blacklist.Search",
  BLACKLIST_CREATE = "Blacklist.Create",
  BLACKLIST_UPDATE = "Blacklist.Update",
  BLACKLIST_DELETE = "Blacklist.Delete",
  BLACKLIST_EXPORT = "Blacklist.Export",

  // APPROVE_VISIT_REQUEST = "APPROVE_VISIT_REQUEST",
  APPROVE_VISIT_REQUEST_SEARCH = "VisitRequest.Approvals", // Listing
  APPROVE_VISIT_REQUEST = "VisitRequest.Approve", // form - Approve
  REJECT_VISIT_REQUEST = "VisitRequest.Reject", // form - Reject
  REQ_MORE_INFO_VISIT_REQUEST = "VisitRequest.RequestMoreInfo", // form - RequestMoreInfo

  // APPROVE_REQUEST = "APPROVE_REQUEST",

  // SEARCH_VISIT_REQUEST = "SEARCH_VISIT_REQUEST",
  UPDATE_REQUEST_SEARCH = "VisitRequest.Search",
  UPDATE_REQUEST_UPDATE = "VisitRequest.Update",
  UPDATE_REQUEST_DELETE = "VisitRequest.Delete",
  UPDATE_REQUEST_EXPORT = "VisitRequest.Export",

  // CREATE_VISIT_REQUEST = "CREATE_VISIT_REQUEST",
  // INDIVIDUAL_VISIT_REQUEST = "INDIVIDUAL_VISIT_REQUEST",
  // GROUP_VISIT_REQUEST = "GROUP_VISIT_REQUEST",
  // VIP_VISIT_REQUEST = "VIP_VISIT_REQUEST",
  UPDATE_REQUEST_CREATE = "VisitRequest.Create",

  PERMIT_REQUEST_SEARCH = "PermitRequest.Search",

  // APPROVE_PERMIT_REQUEST = "APPROVE_PERMIT_REQUEST",
  APPROVE_PERMIT_REQUEST_SEARCH = "PermitRequest.Approvals", // Listing
  APPROVE_PERMIT_REQUEST = "PermitRequest.Approve", // form - Approve

  // ADD_USERS = "ADD_USERS",
  // SEARCH_USERS = "SEARCH_USERS",
  USERS_SEARCH = "Users.Search",
  USERS_CREATE = "Users.Create",
  USERS_UPDATE = "Users.Update",
  USERS_DELETE = "Users.Delete",
  USERS_EXPORT = "Users.Export",

  // MANAGE_ROLES = "MANAGE_ROLES",
  ROLE_PRIVILEGES_SEARCH = "RolePrivileges.Search",
  ROLE_PRIVILEGES_UPDATE = "RolePrivileges.Update",

  INTERNAL_CONFIG = "INTERNAL_CONFIG",

  // SYSTEM_CODES = "SYSTEM_CODES",
  SYSTEM_CODES_SEARCH = "SystemCodes.Search",
  SYSTEM_CODES_CREATE = "SystemCodes.Create",
  SYSTEM_CODES_UPDATE = "SystemCodes.Update",
  SYSTEM_CODES_DELETE = "SystemCodes.Delete",
  SYSTEM_CODES_EXPORT = "SystemCodes.Export",

  // VISIT_PURPOSE = "VISIT_PURPOSE",
  VISIT_PURPOSE_SEARCH = "VisitPurpose.Search",
  VISIT_PURPOSE_CREATE = "VisitPurpose.Create",
  VISIT_PURPOSE_UPDATE = "VisitPurpose.Update",
  VISIT_PURPOSE_DELETE = "VisitPurpose.Delete",
  VISIT_PURPOSE_EXPORT = "VisitPurpose.Export",

  // LOCATIONS = "LOCATIONS",
  LOCATIONS_SEARCH = "Locations.Search",
  LOCATIONS_CREATE = "Locations.Create",
  LOCATIONS_UPDATE = "Locations.Update",
  LOCATIONS_DELETE = "Locations.Delete",
  LOCATIONS_EXPORT = "Locations.Export",

  // DEPARTMENTS = "DEPARTMENTS",
  DEPARTMENTS_SEARCH = "Departments.Search",
  DEPARTMENTS_CREATE = "Departments.Create",
  DEPARTMENTS_UPDATE = "Departments.Update",
  DEPARTMENTS_DELETE = "Departments.Delete",
  DEPARTMENTS_EXPORT = "Departments.Export",

  // MEETING_ROOMS_CONFIG = "MEETING_ROOMS_CONFIG",
  MEETING_ROOMS_SEARCH_ONFIG = "MeetingRooms.Search",
  MEETING_ROOMS_CREATE_CONFIG = "MeetingRooms.Create",
  MEETING_ROOMS_UPDATE_CONFIG = "MeetingRooms.Update",
  MEETING_ROOMS_DELETE_CONFIG = "MeetingRooms.Delete",
  MEETING_ROOMS_EXPORT_CONFIG = "MeetingRooms.Export",

  // ACCESS_LEVELS = "ACCESS_LEVELS",

  // ACTIVE_DIRECTORY_CONFIG = "ACTIVE_DIRECTORY_CONFIG",
  ACTIVE_DIRECTORY_CONFIG_SEARCH = "ActiveDirectory.Search",
  ACTIVE_DIRECTORY_CONFIG_UPDATE = "ActiveDirectory.Update",
  ACTIVE_DIRECTORY_CONFIG_TEST = "ActiveDirectory.Test",

  // DYNAMIC_WORKFLOW_CONFIG = "DYNAMIC_WORKFLOW_CONFIG",
  DYNAMIC_WORKFLOW_CONFIG_SEARCH = "DynamicWorkflow.Search",
  DYNAMIC_WORKFLOW_CONFIG_UPDATE = "DynamicWorkflow.Update",

  // EMAIL_CONFIG = "EMAIL_CONFIG",
  EMAIL_CONFIG_SEARCH = "EmailSettings.Search",
  EMAIL_CONFIG_UPDATE = "EmailSettings.Update",
  EMAIL_CONFIG_TEST = "EmailSettings.Test",

  // SMS_CONFIG
  SMS_CONFIG_SEARCH = "SMSConfig.Search",

  // BUILDINGS_CONFIGURATION = "BUILDINGS_CONFIGURATION",
  BUILDINGS_SEARCH_CONFIGURATION = "Buildings.Search",
  BUILDINGS_CREATE_CONFIGURATION = "Buildings.Create",
  BUILDINGS_UPDATE_CONFIGURATION = "Buildings.Update",
  BUILDINGS_DELETE_CONFIGURATION = "Buildings.Delete",
  BUILDINGS_EXPORT_CONFIGURATION = "Buildings.Export",

  // EXTERNAL_HELP_CONFIG = "EXTERNAL_HELP_CONFIG",
  EXTERNAL_HELP_CONFIG_SEARCH = "ExternalHelpFile.Search",
  EXTERNAL_HELP_CONFIG_UPDATE = "ExternalHelpFile.Update",

  // SMS_CONFIG = "SMS_CONFIG",

  // GATES_CONFIG = "GATES_CONFIG",
  GATES_SEARCH_CONFIG = "Gates.Search",
  GATES_CREATE_CONFIG = "Gates.Create",
  GATES_UPDATE_CONFIG = "Gates.Update",
  GATES_DELETE_CONFIG = "Gates.Delete",
  GATES_EXPORT_CONFIG = "Gates.Export",

  // CRITICAL_NATIONALITIES_CONFIG = "CRITICAL_NATIONALITIES_CONFIG",
  CRITICAL_NATIONALITIES_CONFIG_SEARCH = "CriticalNationalities.Search",
  CRITICAL_NATIONALITIES_CONFIG_UPDATE = "CriticalNationalities.Update",

  // VISIT_REQUEST_REPORT = "VISIT_REQUEST_REPORT",
  VISIT_REQUEST_REPORT_SEARCH = "VisitRequestReport.Search",
  VISIT_REQUEST_REPORT_EXPORT = "VisitRequestReport.Export",

  // ACCESS_LOG_REPORT = "ACCESS_LOG_REPORT",
  ACCESS_LOG_REPORT_SEARCH = "AccessLogReport.Search",
  ACCESS_LOG_REPORT_EXPORT = "AccessLogReport.Export",

  // EMPLOYEE_REPORT = "EMPLOYEE_REPORT",

  // EXTERNAL_USERS_REPORT = "EXTERNAL_USERS_REPORT",
  EXTERNAL_USERS_REPORT_SEARCH = "ExternalUsersReport.Search",
  EXTERNAL_USERS_REPORT_EXPORT = "ExternalUsersReport.Export",

  // AUDIT_LOGS_REPORT = "AUDIT_LOGS_REPORT",
  AUDIT_LOGS_REPORT_SEARCH = "AuditLogsReport.Search",
  AUDIT_LOGS_REPORT_EXPORT = "AuditLogsReport.Export",

  // LOGIN_USER_REPORT = "LOGIN_USER_REPORT",
  LOGIN_USER_REPORT_SEARCH = "LoginUserReport.Search",
  LOGIN_USER_REPORT_EXPORT = "LoginUserReport.Export",

  // RATING
  RATING_REPORT_SEARCH = "Rating.Search",
  RATING_REPORT_EXPORT = "Rating.Export",

  // VISITORS_REPORT = "VISITORS_REPORT",
  VISITORS_REPORT_SEARCH = "VisitorLogReport.Search",
  VISITORS_REPORT_EXPORT = "VisitorLogReport.Export",

  // OVERSTAYED_VISITORS_REPORT = "OVERSTAYED_VISITORS_REPORT",
  OVERSTAYED_VISITORS_REPORT_SEARCH = "VisitorsOverstayReport.Search",
  OVERSTAYED_VISITORS_REPORT_EXPORT = "VisitorsOverstayReport.Export",

  // FR_ERRORS_REPORT = "FR_ERRORS_REPORT",
  FR_ERRORS_REPORT_SEARCH = "FRErrorsReport.Search",
  FR_ERRORS_REPORT_EXPORT = "FRErrorsReport.Export",

  // BLACKLISTING_REPORT = "BLACKLISTING_REPORT"
  BLACKLISTING_REPORT_SEARCH = "BlacklistingReport.Search",
  BLACKLISTING_REPORT_EXPORT = "BlacklistingReport.Export",

  // ADD_EMPLOYEE = "ADD_EMPLOYEE",
  // SEARCH_EMPLOYEE = "SEARCH_EMPLOYEE",

  // VISIT_SUBMITTED = "VISIT_SUBMITTED",
  VISIT_SUBMITTED_SEARCH = "VisitSubmittedTemplate.Search",
  VISIT_SUBMITTED_UPDATE = "VisitSubmittedTemplate.Update",

  // VISIT_REQUEST_SCHEDULE_TEMPLATE = "VISIT_REQUEST_SCHEDULE_TEMPLATE",
  VISIT_REQUEST_SCHEDULE_TEMPLATE_SEARCH = "VisitRequestScheduleTemplate.Search",
  VISIT_REQUEST_SCHEDULE_TEMPLATE_UPDATE = "VisitRequestScheduleTemplate.Update",

  // VISIT_APPROVED_HOST_EMAIL = "VISIT_APPROVED_HOST_EMAIL",
  VISIT_APPROVED_HOST_EMAIL_SEARCH = "VisitApprovedHostEmailTemplate.Search",
  VISIT_APPROVED_HOST_EMAIL_UPDATE = "VisitApprovedHostEmailTemplate.Update",

  // FINAL_PERMIT_APPROVAL_SEARCH
  FINAL_PERMIT_APPROVAL_SEARCH = "FinalPermitApprovalTemplate.Search",
  FINAL_PERMIT_APPROVAL_UPDATE = "FinalPermitApprovalTemplate.Update",

  // EMERGENCY_EVACUATION_TEMPLATE
  EMERGENCY_EVACUATION_TEMPLATE_SEARCH = "EvacuationTemplate.Search",
  EMERGENCY_EVACUATION_TEMPLATE_UPDATE = "EvacuationTemplate.Update",

  // VISIT_REJECTED_HOST_EMAIL = "VISIT_REJECTED_HOST_EMAIL",
  VISIT_REJECTED_HOST_EMAIL_SEARCH = "VisitRejectedHostEmailTemplate.Search",
  VISIT_REJECTED_HOST_EMAIL_UPDATE = "VisitRejectedHostEmailTemplate.Update",

  // VISIT_REQUEST_REJECTED_TEMPLATE = "VISIT_REQUEST_REJECTED_TEMPLATE",
  VISIT_REQUEST_REJECTED_TEMPLATE_SEARCH = "VisitRequestRejectedEmailTemplate.Search",
  VISIT_REQUEST_REJECTED_TEMPLATE_UPDATE = "VisitRequestRejectedEmailTemplate.Update",

  // EMAIL_TO_HOST_TEMPLATE = "EMAIL_TO_HOST_TEMPLATE",
  EMAIL_TO_HOST_TEMPLATE_SEARCH = "EmailToHostEmailTemplate.Search",
  EMAIL_TO_HOST_TEMPLATE_UPDATE = "EmailToHostEmailTemplate.Update",

  // EXTERNAL_ACCOUNT_REGISTRATION_TEMPLATE = "EXTERNAL_ACCOUNT_REGISTRATION_TEMPLATE",
  EXTERNAL_ACCOUNT_REGISTRATION_TEMPLATE_SEARCH = "ExternalAccountRegistrationTemplate.Search",
  EXTERNAL_ACCOUNT_REGISTRATION_TEMPLATE_UPDATE = "ExternalAccountRegistrationTemplate.Update",

  // EXTERNAL_CANCEL_VISIT_REQUEST_TO_HOST = "EXTERNAL_CANCEL_VISIT_REQUEST_TO_HOST",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_HOST_SEARCH = "ExternalCancelVisitRequestToHostTemplate.Search",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_HOST_UPDATE = "ExternalCancelVisitRequestToHostTemplate.Update",

  // EXTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR = "EXTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR_SEARCH = "ExternalCancelVisitRequestToVisitorTemplate.Search",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR_UPDATE = "ExternalCancelVisitRequestToVisitorTemplate.Update",

  // INTERNAL_CANCEL_VISIT_REQUEST_TO_HOST = "INTERNAL_CANCEL_VISIT_REQUEST_TO_HOST",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_HOST_SEARCH = "InternalCancelVisitRequestToHostTemplate.Search",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_HOST_UPDATE = "InternalCancelVisitRequestToHostTemplate.Update",

  // INTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR = "INTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR_SEARCH = "InternalCancelVisitRequestToVisitorTemplate.Search",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR_UPDATE = "InternalCancelVisitRequestToVisitorTemplate.Update",

  // EXTERNAL_PASSWORD_RESET = "EXTERNAL_PASSWORD_RESET",
  EXTERNAL_PASSWORD_RESET_SEARCH = "ExternalPasswordResetTemplate.Search",
  EXTERNAL_PASSWORD_RESET_UPDATE = "ExternalPasswordResetTemplate.Update",

  // VISIT_REQUESTED_INFO_TO_VISITOR = "VISIT_REQUESTED_INFO_TO_VISITOR",
  VISIT_REQUESTED_INFO_TO_VISITOR_SEARCH = "VisitRequestedForInformationToVisitorTemplate.Search",
  VISIT_REQUESTED_INFO_TO_VISITOR_UPDATE = "VisitRequestedForInformationToVisitorTemplate.Update",

  // VISIT_REQUESTED_INFO_TO_STAFF = "VISIT_REQUESTED_INFO_TO_STAFF",
  VISIT_REQUESTED_INFO_TO_STAFF_SEARCH = "VisitRequestedForInformationToHostTemplate.Search",
  VISIT_REQUESTED_INFO_TO_STAFF_UPDATE = "VisitRequestedForInformationToHostTemplate.Update",

  // VISITOR_CHECK_IN = "VISITOR_CHECK_IN",
  VISITOR_CHECK_IN_SEARCH = "VisitorCheckInTemplate.Search",
  VISITOR_CHECK_IN_UPDATE = "VisitorCheckInTemplate.Update",

  // VISITOR_CHECK_OUT = "VISITOR_CHECK_OUT",
  VISITOR_CHECK_OUT_SEARCH = "VisitorCheckOutTemplate.Search",
  VISITOR_CHECK_OUT_UPDATE = "VisitorCheckOutTemplate.Update",

  // ACCESS_GROUPS = "ACCESS_GROUPS",
  ACCESS_GROUPS_SEARCH = "AccessGroups.Search",
  ACCESS_GROUPS_CREATE = "AccessGroups.Create",
  ACCESS_GROUPS_UPDATE = "AccessGroups.Update",
  ACCESS_GROUPS_DELETE = "AccessGroups.Delete",
  ACCESS_GROUPS_EXPORT = "AccessGroups.Export",

  // OTP_TEMPLATE = "OTP_TEMPLATE",
  OTP_TEMPLATE_SEARCH = "OTPTemplate.Search",
  OTP_TEMPLATE_UPDATE = "OTPTemplate.Update",

  // FR_DEVICES_CONFIG = "FR_DEVICES_CONFIG",
  FR_DEVICES_CONFIG_SEARCH = "Devices.Search",
  FR_DEVICES_CONFIG_CREATE = "Devices.Create",
  FR_DEVICES_CONFIG_UPDATE = "Devices.Update",
  FR_DEVICES_CONFIG_DELETE = "Devices.Delete",
  FR_DEVICES_CONFIG_EXPORT = "Devices.Export",

  // FR_CONFIG = "FR_CONFIG",
  FR_CONFIG_SEARCH = "FRSettings.Search",
  FR_CONFIG_UPDATE = "FRSettings.Update",

  // EMERGENCY_EVACUATION = "EMERGENCY_EVACUATION",
  EMERGENCY_EVACUATION_CREATE = "EmergencyEvacuation.Create",
  EMERGENCY_EVACUATION_SEARCH = "EmergencyEvacuation.Search",
  EMERGENCY_EVACUATION_REPORT_SEARCH = "EmergencyEvacuationReport.Search",

  // MUSTER_POINTS = "MUSTER_POINTS",
  MUSTER_POINTS_SEARCH = "MusterPoints.Search",
  MUSTER_POINTS_CREATE = "MusterPoints.Create",
  MUSTER_POINTS_UPDATE = "MusterPoints.Update",
  MUSTER_POINTS_DELETE = "MusterPoints.Delete",
  MUSTER_POINTS_EXPORT = "MusterPoints.Export",
}
